import { Pipe, PipeTransform } from '@angular/core';
import { CryptoService } from '../../services/crypto.service';

@Pipe({
  name: 'aesDecrypt'
})
export class AesDecryptPipe implements PipeTransform {
  constructor(private aesService: CryptoService) { }

  transform(value: string): string {
    try {
      return this.aesService.decrypt(value);
    } catch {
      return value;
    }
  }
}
